import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppUsersDocs } from '../models/appUsersDocs.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable()
export class AppUsersDocsService extends HttpClientBaseService implements IServiceBase<AppUsersDocs> {

  constructor(_http: HttpClient) {
    super(_http, '/app-docs/', '', false);

  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppUsersDocs>> {
    throw new Error('Method not implemented.');
  }

  /*   getAllModels(): Observable<AppSolicitudes[]> {
      return super.getAll<AppSolicitudes[]>();
    } */


  getAllModels(): Observable<AppUsersDocs[]> {

    const url = `${AppConfig.settings.apiServerPE.apiUrl}docsuser?orderBy=createdAt&order=desc`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppUsersDocs[]>(url, { headers: headers });
  }

  getModel(id: any): Observable<AppUsersDocs> {
    return super.getSingle<AppUsersDocs>(id);
  }

  getDocsFromUser(user: string) {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}docsuser?fields=user&operator=eq&values=${user}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición get
    return this.http.get<AppUsersDocs[]>(url, { headers: headers });
  }

  updateUsersToDoc(data: any) {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}docsuser/addmultipleuserstodoc`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición POST
    return this.http.post<AppUsersDocs[]>(url, data, { headers: headers });
  }

  updateDocToUser(data: any) {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}docsuser/addmultipledocstouser`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición POST
    return this.http.post<AppUsersDocs[]>(url, data, { headers: headers });
  }

  deleteDocUserRelation(data: any) {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}docsuser/deletedocuserrelation`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición POST
    return this.http.delete<AppUsersDocs[]>(url, { headers: headers, body: data });
  }


  /* public setName(setName: SetPasswordModel): Observable<Object> {
    const url = `${this.getConcatUrl()}setPassword/`;
    return this.http.post(url, setPassword, {responseType:'text'});
  }
 
  public isAdmin(userName: string): Observable<boolean> {
    const url = `${super.getBaseUrl}/isAdmin/${userName}`;
    return super.get<boolean>(url);
  }
 */
  /*   public generateA3LUsers(users: UsersA3LModel){
      const url = `${this.getConcatUrl()}A3LEmployeesRegister/`;
      return this.http.post(url,users);
    }
  
    public selectCompany(userA3lRelations: UserA3LRelations){
      const url = `${this.getConcatUrl()}SelectCompany/`;
      return this.http.post(url, userA3lRelations);
    } */
}